import { API_URL } from '../constants/config'
import { query } from './utilities'
import { SetApplicationRole } from '../actions/applicationRoleActions'
import {
  WaitOnProposalAcceptanceSubmission,
  WaitOnCancelProposalAcceptanceSubmission,
  OnProposalAcceptanceFailed,
  OnCancelProposalAcceptanceFailed,
  OnCancelProposalAcceptanceSuccess,
} from '../actions/proposalsActions'
import { applicationRoles } from '../constants/actionTypes'
import { COMMON_ERROR_MESSAGE } from '../constants/messages'

export const OnProposalAcceptance = (
  opportunityId,
  inputDetails,
  dispatch,
  history
) => {
  dispatch(WaitOnProposalAcceptanceSubmission())
  query(`${API_URL}/opportunity/${opportunityId}/proposal/oly`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(inputDetails),
  }).then(
    (data) => {
      dispatch(SetApplicationRole(applicationRoles.USER_WITH_PROPOSAL_ACCEPTED))
      history.push('/proposal/accepted')
    },
    (error) => {
      if (!isNaN(error)) {
        error = COMMON_ERROR_MESSAGE
      }
      dispatch(
        OnProposalAcceptanceFailed(error.replace('400', '').replace('500', ''))
      )
    }
  )
}

export const OnCancelProposalAcceptance = (
  opportunityId,
  inputDetails,
  dispatch
) => {
  dispatch(WaitOnCancelProposalAcceptanceSubmission())
  query(`${API_URL}/opportunity/${opportunityId}/proposal/oly`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(inputDetails),
  }).then(
    (data) => {
      dispatch(SetApplicationRole(applicationRoles.USER_WITH_PROPOSAL_SETUP))
      dispatch(OnCancelProposalAcceptanceSuccess())
    },
    (error) => {
      if (!isNaN(error)) {
        error = COMMON_ERROR_MESSAGE
      }
      dispatch(OnCancelProposalAcceptanceFailed(error))
    }
  )
}
